import {
    joinSkypeMeetingButton_0,
    joinTeamsMeetingButton_0,
    agendaJoinButtonText,
} from './getProviderDetails.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';

export function getProviderDetails(
    provider: string
): { icon: string | null; providerString: string } {
    switch (provider) {
        case 'SkypeForBusiness':
            return {
                icon: ControlIcons.SkypeForBusinessLogo16,
                providerString: loc(joinSkypeMeetingButton_0),
            };
        case 'SkypeForConsumer':
            return {
                icon: ControlIcons.SkypeLogo16,
                providerString: loc(joinSkypeMeetingButton_0),
            };
        case 'TeamsForBusiness':
            return { icon: ControlIcons.TeamsLogo, providerString: loc(joinTeamsMeetingButton_0) };
        default:
            return { icon: null, providerString: loc(agendaJoinButtonText) };
    }
}
